// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.campaign.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import {
  legacyCampaignSearchToNavigate,
  replacePathRedirect,
} from "./askPunttPaths";
import AskPunttCampaign from "./campaign";
import { parseCampaignSearch } from "./campaignSearch";

import PendingComponent from "../../components/PendingComponent";
import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

// campaignSearch lives in its own module so it is the single source of truth:
// rembrandt's cross-layer AI-behavior contract tests read campaignSearch.ts
// directly (services/rembrandt/tests/test_review_agent.py,
// test_review_service_run.py) to assert the FE chatId normalization the review
// pipeline depends on. Re-exported here so existing
// `import { campaignSearch } from "./campaignRoute"` call sites keep working
// without the file diverging from a second hand-rolled copy.
export {
  campaignSearch,
  parseCampaignSearch,
  type CampaignSearch,
} from "./campaignSearch";

export const campaignRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/projects/$projectId",
  validateSearch(search: Record<string, unknown>) {
    return parseCampaignSearch(search);
  },
  beforeLoad({
    params,
    search,
  }: {
    params: { projectId: string };
    search: Record<string, unknown>;
  }) {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to });
    }
    const parsed = parseCampaignSearch(search);
    const commentRaw =
      typeof search.comment === "string" ? search.comment.trim() : undefined;
    const target = legacyCampaignSearchToNavigate(params.projectId, {
      ...parsed,
      comment: commentRaw,
    });
    if (target) {
      throw redirect(replacePathRedirect(target) as never);
    }
  },
  component: AskPunttCampaign,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: true,
  pendingMs: 0,
  pendingMinMs: 500,
});
